/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A navigation solution for VDK Web. (@accedo/vdkweb-navigation) 6.2.5
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var lineParser = function lineParser(line) {
  var strArr = line.split(' ');
  var output = [];
  for (var i = 0, l = strArr.length; i < l; i += 1) {
    var str = strArr[i];
    if (str !== '' && str[0] !== '.') {
      output.push(str);
    } else if (str[0] === '.') {
      output.push(null);
    }
  }
  return output;
};
var layoutParser = function layoutParser(layout) {
  var lineArr = layout.split('\n');
  var output = [];
  for (var i = 0, l = lineArr.length; i < l; i += 1) {
    var line = lineArr[i];
    output.push(lineParser(line));
  }
  return output;
};
var findNextLeft = function findNextLeft(layout, topLeft, bottomLeft) {
  if (topLeft[1] === 0) {
    return '';
  }
  for (var i = topLeft[1] - 1; i >= 0; i -= 1) {
    for (var ii = topLeft[0]; ii <= bottomLeft[0]; ii += 1) {
      if (layout[ii][i]) {
        return layout[ii][i];
      }
    }
  }
  return '';
};
var findNextRight = function findNextRight(layout, topRight, bottomRight) {
  if (topRight[1] === layout[0].length - 1) {
    return '';
  }
  for (var i = topRight[1] + 1; i <= layout[0].length - 1; i += 1) {
    for (var ii = topRight[0]; ii <= bottomRight[0]; ii += 1) {
      if (layout[ii][i]) {
        return layout[ii][i];
      }
    }
  }
  return '';
};
var findNextUp = function findNextUp(layout, topLeft, topRight) {
  if (topLeft[0] === 0) {
    return '';
  }
  for (var i = topLeft[0] - 1; i >= 0; i -= 1) {
    for (var ii = topLeft[1]; ii <= topRight[1]; ii += 1) {
      if (layout[i][ii]) {
        return layout[i][ii];
      }
    }
  }
  return '';
};
var findNextDown = function findNextDown(layout, bottomLeft, bottomRight) {
  if (bottomLeft[0] === layout.length - 1) {
    return '';
  }
  for (var i = bottomLeft[0] + 1; i <= layout.length - 1; i += 1) {
    for (var ii = bottomLeft[1]; ii <= bottomRight[1]; ii += 1) {
      if (layout[i][ii]) {
        return layout[i][ii];
      }
    }
  }
  return '';
};
var withLayout = function withLayout(Component) {
  var XXX = /*#__PURE__*/function (_React$Component) {
    _inherits(XXX, _React$Component);
    var _super = _createSuper(XXX);
    function XXX(props) {
      var _this;
      _classCallCheck(this, XXX);
      _this = _super.call(this, props);
      _this.updateLayout();
      return _this;
    }
    _createClass(XXX, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.layout === prevProps.layout) {
          return;
        }
        this.updateLayout();
      }
    }, {
      key: "updateLayout",
      value: function updateLayout() {
        var layoutString = this.props.layout;
        this.layout = layoutParser(layoutString);
      }
    }, {
      key: "updateNav",
      value: function updateNav() {
        var nav = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var topLeft;
        var topRight;
        var bottomLeft;
        var bottomRight;
        var parent = this.props.nav.id;
        for (var i = 0, l = this.layout.length; i < l; i += 1) {
          var line = this.layout[i];
          for (var ii = 0, ll = line.length; ii < ll; ii += 1) {
            var item = line[ii];
            if (item === nav.id) {
              if (!topLeft) {
                topLeft = [i, ii];
              }
              if (topLeft && (!topRight || topRight[1] < ii)) {
                topRight = [i, ii];
              }
              if (topLeft && topRight && (!bottomLeft || bottomLeft[0] < i)) {
                bottomLeft = [i, ii];
              }
              if (topLeft && topRight && bottomLeft && (!bottomRight || bottomRight[0] < i || bottomRight[1] < ii)) {
                bottomRight = [i, ii];
              }
            }
            if (topLeft && !topRight && ii === ll - 1) {
              topRight = topLeft;
            }
            if (topLeft && topRight && !bottomLeft && i === l - 1) {
              bottomLeft = topLeft;
              bottomRight = topRight;
            }
          }
        }
        if (topLeft) {
          var nextleft = findNextLeft(this.layout, topLeft, bottomLeft);
          var nextright = findNextRight(this.layout, topRight, bottomRight);
          var nextup = findNextUp(this.layout, topLeft, topRight);
          var nextdown = findNextDown(this.layout, bottomLeft, bottomRight);
          var output = {
            parent: parent,
            nextleft: nextleft,
            nextright: nextright,
            nextup: nextup,
            nextdown: nextdown
          };
          return output;
        }
        return {};
      }
    }, {
      key: "renderChildren",
      value: function renderChildren() {
        var _this2 = this;
        var children = this.props.children;
        return _react["default"].Children.map(children, function (child) {
          if (!child.props.nav) {
            return child;
          }
          var newNav = _this2.updateNav(child.props.nav);
          var mergedNav = (0, _immutabilityHelper["default"])(child.props.nav, {
            $merge: newNav
          });
          return /*#__PURE__*/_react["default"].cloneElement(child, {
            nav: mergedNav
          });
        });
      }
    }, {
      key: "render",
      value: function render() {
        var newNav = _objectSpread(_objectSpread({}, this.props.nav), {}, {
          useLastFocus: true
        });
        var newProps = _objectSpread(_objectSpread({}, this.props), {}, {
          nav: newNav
        });
        return /*#__PURE__*/_react["default"].createElement(Component, newProps, this.renderChildren());
      }
    }]);
    return XXX;
  }(_react["default"].Component);
  XXX.propTypes = {
    children: _propTypes["default"].node,
    layout: _propTypes["default"].string,
    nav: _propTypes["default"].object
  };
  return XXX;
};
var _default = withLayout;
exports["default"] = _default;